import { BaseFirestoreRepository } from 'core/base-firestore.repository';

import { CashBook } from './cash-book.model';

export default class CashBookRepository extends BaseFirestoreRepository<CashBook> {
  constructor() {
    super('chefs_assistant_cash_book');
  }

  async getAllOrderTransactionCode() {
    return this.getAll([['transactionCode', 'asc']]);
  }
}
